module.exports = {
      url: "https://api2.robbiert.com" ,
      drift_id: "i532prgxgy29" ,
      sentry_dns: "https://5659a6f0794341fdb6c5d13ce6f72c02@o470428.ingest.sentry.io/4504982378905600" ,
      is_production: true,
      mapboxgl_token: "pk.eyJ1Ijoicm9iYmllcmVzdG9yYXRpb250ZWNoIiwiYSI6ImNtMmFsbm05MTBobGQybHB0cXUzeW1wY2YifQ.MJAwcB6JU7b9VbRgjsUFuA"
      };
